import BioAdmin from '../../../types/ba/bioAdmin';
import _ from 'lodash';
import {IBioResultsSorter} from '../../../types/ba/bioAdmin';

export default class BioResultsSorter implements IBioResultsSorter {

	public sortByPublishStatus(group: BioAdmin.ITeamMemberListProfile[]): BioAdmin.ITeamMemberListProfile[] {
		const sortedList: BioAdmin.ITeamMemberListProfile[] = [];
		sortedList.push.apply(sortedList, this.filterByStatus(group, 'submitted'));
		sortedList.push.apply(sortedList, this.filterByStatus(group, 'rejected'));
		sortedList.push.apply(sortedList, this.filterByStatus(group, 'pending'));
		sortedList.push.apply(sortedList, this.filterByStatus(group, 'published'));
		sortedList.push.apply(sortedList, this.filterByStatus(group, ''));
		return sortedList;
	}

	private filterByStatus(group: BioAdmin.ITeamMemberListProfile[], filter: string): BioAdmin.ITeamMemberListProfile[] {
		let filteredGroup: BioAdmin.ITeamMemberListProfile[] = _.filter(group, (tmlp: BioAdmin.ITeamMemberListProfile) => {
			return tmlp.publishStatus === filter;
		});
		filteredGroup = this.sortMembers(filteredGroup);
		return filteredGroup;
	}

	private sortMembers(group: BioAdmin.ITeamMemberListProfile[]) {
		const sortedList: BioAdmin.ITeamMemberListProfile[] = [];
		// sort by active testimonials first
		const testimonialGroup = _.filter(group, (tmlp: BioAdmin.ITeamMemberListProfile) => {
			return tmlp.testimonials > 0;
		});
		// add testimonials group to top of group list, sorted by name
		sortedList.push.apply(sortedList, this.sortNames(testimonialGroup));
		// sort by non-pending testimonials
		const nonTestimonialGroup = _.filter(group, (tmlp: BioAdmin.ITeamMemberListProfile) => {
			return tmlp.testimonials === 0;
		});
		// add non-pending testimonials group to end of group list, sorted by name
		sortedList.push.apply(sortedList, this.sortNames(nonTestimonialGroup));
		return sortedList;
	}

	private sortNames(group: BioAdmin.ITeamMemberListProfile[]) {
		group = group.sort((a, b) => {
			const textA = a.name.toUpperCase();
			const textB = b.name.toUpperCase();
			return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
		});
		return group;
	}
}
